import { FC, memo } from 'react'

import { Icon, IconName } from 'ui/components/Icon'

import { GlobalSearchItem } from '../../../../types/GlobalSearchResponse'
import { formatItemDisplayText } from './utils/formatItemDisplayText'

import { s } from './styles'

type ResultItemProps = {
  item: GlobalSearchItem
  searchText: string
  isActive: boolean
  onClick?: () => void
  onFocus?: () => void
  tabIndex?: number
  setIsActive: () => void
}

export const ResultItem: FC<ResultItemProps> = memo(
  ({ item, searchText, isActive, onClick, tabIndex, setIsActive }) => {
    const highlightedText = formatItemDisplayText(item, searchText)

    return (
      <s.ResultItem
        className={`result-item ${isActive ? 'active' : ''}`}
        tabIndex={tabIndex}
        onClick={onClick}
        onMouseEnter={() => setIsActive()}
        $isActive={isActive}
      >
        <s.ResultItemContent>
          <Icon name={IconName.SEARCH} />
          <span>{highlightedText}</span>
        </s.ResultItemContent>
      </s.ResultItem>
    )
  }
)
